<template>
  <v-main>
    <core-warnings />
    <core-toolbar />
    <core-drawer />
    <div id="core-view">
      <router-view :key="$route.path" />
    </div>
    <helper-suspended />
  </v-main>
</template>

<script>
import { mapMutations } from "vuex";
import USER_SETTINGS_QUERY from "@/graphql/queries/UserSettings.gql";


export default {
  methods: {
    ...mapMutations("user", ["setUserSettings"]),
  },
  apollo: {
    userSettings: {
      query: USER_SETTINGS_QUERY,
      pollInterval: 60 * 1000,
      result({ loading, data}) {
        if (!loading) {
          this.setUserSettings(data.userSettings)
        }
      }
    }
  } 
}
</script>

<style>

</style>
